import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/trunk_shows";

export default class TrunkShows extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("Trunk Shows")} | ${this.ucfirst("window-title")}`
    );
  }

  onUpdate(prevProps, prevState, snapshot) {
    super.onUpdate(prevProps, prevState, snapshot);

    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.getComponents().findById("trunk-shows").first().setTrunkShows();
    }
  }
}
